<template>
  <button class='toggle-image' :class="[orientation, showImage ? 'show-image' : '']" @click="showImage = !showImage ; $emit('click')">
        <svg width="5" height="10" viewBox="0 0 5 10" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 10l5-5-5-5z" fill="#000" fill-rule="nonzero"/>
        </svg>     
    </button>
</template>

<script>
export default {
    name:'ShowImageArrow',
    props: {  
      orientation : {
          default:'horizontal',
          type:String
      },
      showImage: {
          default:false,
          type:Boolean
      }
  },
}
</script>

<style lang="scss" scoped>
    button {
        position:absolute;        
        background-image: linear-gradient(270deg, #F5831F 0%, #FFD62F 100%);
        border: 1px solid #222222;
        border-radius: 3px;        
        z-index: 1;
        &.vertical {
            width:30px;
            height:70px;
            transition: left 0.5s; 
        }
        &.horizontal {
            width:70px;
            height:30px;
            transition: bottom 0.5s; 
            svg {
                transform: rotateZ(90deg);
            }
        }
    }
    button.show-image {
        &.vertical svg {
            transform: rotateZ(180deg);
        }
        &.horizontal svg {
            transform: rotateZ(270deg);
        }
    }
</style>